<template>
  <section :class="$style.section">
    <header :class="[$style.section__header, $style.header]">
      <SectionTitle :class="$style.header__title">お知らせ</SectionTitle>
      <DirectionalLink
        :class="$style.header__link"
        text="すべて見る"
        :to="{ name: 'news' }"
        v-if="articles.length > 0"
      />
    </header>
    <section :class="[$style.section__contents, $style.contents]">
      <FadeTransition>
        <AdminNewsList
          :articles="articles"
          v-if="articles.length > 0"
          :class="$style.contents__list"
        />
        <p
          :class="[
            $style.contents__message,
            $style['contents__message--empty'],
          ]"
          v-else
        >
          お知らせはありません
        </p>
      </FadeTransition>
    </section>
  </section>
</template>

<script lang="ts" setup>
import SectionTitle from '@/components/atoms/SectionTitle.vue'
import DirectionalLink from '@/components/atoms/DirectionalLink.vue'
import FadeTransition from '@/components/transitions/FadeTransition.vue'
import AdminNewsList from '@/features/adminNews/components/AdminNewsList/AdminNewsList.vue'
import { computed } from 'vue'
import { type DashboardPageNewsSectionNewsForPlannerFragment } from './DashboardPageNewsSection.generated'

const props = defineProps<{
  query: DashboardPageNewsSectionNewsForPlannerFragment
}>()

const articles = computed(() => {
  return props.query.newsForPlanner.edges.map(({ node }) => node)
})
</script>

<style lang="scss" module>
.header {
  display: flex;

  &__title {
    flex-grow: 1;
  }
}

.section {
  &__title {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }

  &__contents {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}

.contents {
  display: flex;
  overflow: hidden;
  min-height: 88px;
  align-items: center;
  justify-content: center;
  background-color: $color-surface-primary;
  border-radius: $border-radius-v2-rounder;
  box-shadow: $shadow-20;

  &__list {
    width: 100%;
  }

  &__message {
    &--empty {
      color: $color-text-and-object-low-emphasis;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
